import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import appStore from "../store/appStore";
import {fetchOrderCountStatusAllTime, fetchOrderDetail} from "../services/orderServices";
import {navigateWithSearchUpdates} from "../utils";

/**
 * Sau khi đơn đổi trạng thái: cập nhật URL status, refresh số đếm tab, refresh chi tiết đơn.
 * Callbacks giữ thứ tự giống logic cũ (popup / tab giữa các bước).
 */
export function useSyncOrderAfterStatusChange() {
  const navigate = useNavigate();
  const {setLoading} = appStore();

  return useCallback(
    (orderId, status, options = {}) => {
      const {scroll = true, beforeFetchCounts, afterFetchCounts} = options;
      navigateWithSearchUpdates(navigate, {status}, {scroll});
      beforeFetchCounts?.();
      fetchOrderCountStatusAllTime().then();
      afterFetchCounts?.();
      return fetchOrderDetail(orderId).then((res) => {
        if (res) setLoading(false);
        return res;
      });
    },
    [navigate, setLoading]
  );
}
